import { useTranslation } from 'react-i18next'

import clsx from 'clsx'

import { MIN_MPLUS_PRICE } from 'shared/constants'
import { priceShow } from 'shared/lib/priceShow'

import { PaymentIcon } from '../payment-icon'

import s from './styles.module.scss'

export const DisabledMplusOption = () => {
  const { t } = useTranslation()

  return (
    <div className={s.container}>
      <PaymentIcon variant="mplusInactive" />

      <p className={clsx(s.title, 'semi-bold-14')}>
        {`${t('mplus.disabled_mplus')} ${t('mplus.from_thousand', {
          price: priceShow(String(MIN_MPLUS_PRICE)),
        })}`}
      </p>
    </div>
  )
}
